import React from "react";
import { useUser } from "@clerk/clerk-react";
import AppShell from "@/components/layout/AppShell";
import BetaSignupSplash from "@/components/beta/BetaSignupSplash";
import ForcePasswordChange from "@/components/auth/ForcePasswordChange";

export default function WorkspaceHome() {
  const { isSignedIn, isLoaded, user } = useUser();

  // Prefer showing the splash while auth is unresolved to avoid flashing the app
  const showSplash = !isLoaded || !isSignedIn;

  if (showSplash) {
    return <BetaSignupSplash />;
  }

  if (user?.unsafeMetadata?.must_change_password) {
    return <ForcePasswordChange />;
  }

  return <AppShell />;
}
